import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from "@/lib/api";

const AuthContext = createContext(null);

function getStoredToken() {
  return localStorage.getItem("access_token");
}

function setStoredToken(token) {
  localStorage.setItem("access_token", token);
}

function clearStoredToken() {
  localStorage.removeItem("access_token");
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const token = getStoredToken();

      if (!token) {
        setUser(false);
        setLoading(false);
        return;
      }

      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      clearStoredToken();
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });

      if (!data?.access_token) {
        throw new Error("Invalid login response");
      }

      setStoredToken(data.access_token);
      setUser(data.user);
      return data;
    } catch (err) {
      console.error("LOGIN ERROR:", err);
      throw err;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
    }
    clearStoredToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
